import { BaseService } from "@/api/services/baseService";
import { shippingRequestHttp } from "@/api";
import type { ShippingServiceProviderConfig } from "@zhihaoscm/entity";

export class ServiceProviderConfigService extends BaseService<
    ShippingServiceProviderConfig,
    ShippingServiceProviderConfig,
    any,
    any
> {
    // 查询服务商配置
    public async find(): Promise<ShippingServiceProviderConfig[]> {
        const { data } = await this.service.get(`${this.path}/find`);
        return data;
    }
}

export const serviceProviderConfigService = new ServiceProviderConfigService(
    "/service-provider/config",
    shippingRequestHttp.service
);
